<template lang="pug">
#betslip-single-mmo.modal.modal-bottom.fade.modal-betslip(tabindex='-1' role='dialog' aria-labelledby='betslip-single' aria-hidden='true')
  .modal-dialog.modal-dialog-scrollable.m-0(role='document')
    .modal-content
      .modal-body.p-0
        template(v-if="!isDataExists")
          .bet-slip
            .bet-slip-wrapper
              .stake-info-wrapper
                .close(@click="hideMe()")
                  i.fal.fa-times
                span No Bet
                .stake-info
                  .betslip-match.text-left(v-if="!loading.check") {{ $t("message.bet_empty") }}
                  .betslip-match(v-else)
                    i.fad.fa-spinner.fa-spin
        template(v-else)
          .bet-slip
            .bet-slip-wrapper(:class="{ live: betsinglemmo.marketType == 3 }")
              .stake-info-wrapper
                .close(@click="hideMe()")
                  i.fal.fa-times
                .bet-league
                  img.icon(:src="'/images/icon-sport-svg/' + getSportsImage(betsinglemmo.sportsType)")
                  template(v-if="racingList.includes(betsinglemmo.sportsType)")
                    span {{ sports[betsinglemmo.sportsType] }}
                  template(v-else)
                    span {{ sports[betsinglemmo.sportsType] }} - {{ betTypeDisplay }}
                .stake-info
                  .betslip-match
                    .team-involved
                      template(v-if="racingList.includes(betsinglemmo.sportsType)")
                        template(v-if="racingList2.includes(betsinglemmo.sportsType)")
                          template(v-if="['ML','1X2'].includes(betsinglemmo.betType)")
                            span {{ betsinglemmo.homeAway == 1 ? betsinglemmo.homeName : betsinglemmo.awayName }}
                          template(v-if="['OU','OE'].includes(betsinglemmo.betType)")
                            span {{ betsinglemmo.homeName }}
                          template(v-if="['CS'].includes(betsinglemmo.betType)")
                            span {{ ['5-0','4-1','3-2'].includes(betsinglemmo.betDisplay) ? betsinglemmo.homeName : betsinglemmo.awayName }}
                        template(v-if="racingList6.includes(betsinglemmo.sportsType) || racingList7.includes(betsinglemmo.sportsType)")
                          template(v-if="['ML'].includes(betsinglemmo.betType)")
                            span {{ betsinglemmo.homeAway == 1 ? betsinglemmo.homeName : betsinglemmo.awayName }}
                          template(v-else-if="['CS','OE'].includes(betsinglemmo.betType)")
                            span {{ betsinglemmo.homeName }} vs {{ betsinglemmo.awayName }}
                        template(v-else)
                          span {{ betsinglemmo.homeName }}
                        span.small.ml-1(v-if="racingList.includes(betsinglemmo.sportsType) && betsinglemmo.matchTime") (No. {{ $dayjs(betsinglemmo.matchTime).format("MMDDhhmm") }})
                      template(v-else)
                        //- .score(v-if="betsinglemmo.marketType == 3 && betsinglemmo.score != ''") {{ betsinglemmo.score }}
                        //- span(:class="betsinglemmo.giving == 1 && isBallDisplay ? 'team2' : 'team1'") {{ betsinglemmo.homeName }}
                        //- span.vs(v-if="betsinglemmo.betType != 'OR'") - VS -
                        //- span(:class="betsinglemmo.giving == 0 && isBallDisplay ? 'team2' : 'team1'" v-if="betsinglemmo.betType != 'OR'") {{ betsinglemmo.awayName }}
                        .new
                          span.d-block {{ betsinglemmo.leagueName }}
                          span.d-block(:class="betsinglemmo.giving == 1 && isBallDisplay ? 'team2' : 'team1'") {{ betsinglemmo.homeName }}
                          span.d-block(:class="betsinglemmo.giving == 0 && isBallDisplay ? 'team2' : 'team1'" v-if="betsinglemmo.betType != 'OR'") {{ betsinglemmo.awayName }}
                  .selector-odd.d-flex.justify-content-between
                    template(v-if="racingList.includes(betsinglemmo.sportsType)")
                      template(v-if="racingList1.includes(betsinglemmo.sportsType)")
                        span.bet-type-text(v-if="['OU','OE'].includes(betsinglemmo.betType)") {{ $t("m.GH_" + betsinglemmo.betDisplay.toUpperCase()) }}
                        span.bet-type-text(v-else) {{ $t("m.GH_" + betsinglemmo.betType + (betsinglemmo.ballDisplay == undefined ? '' : betsinglemmo.ballDisplay)) }}
                      template(v-if="racingList2.includes(betsinglemmo.sportsType)")
                        span.bet-type-text(v-if="['OU','OE'].includes(betsinglemmo.betType)") {{ $t("m.GC_" + betsinglemmo.betDisplay.toUpperCase()) }}
                        span.bet-type-text(v-else-if="['CS'].includes(betsinglemmo.betType)") {{ betsinglemmo.betDisplay }}
                        span.bet-type-text(v-else) {{ $t("m.GC_" + betsinglemmo.betType + (betsinglemmo.ballDisplay == undefined ? '' : betsinglemmo.ballDisplay)) }}
                      template(v-if="racingList3.includes(betsinglemmo.sportsType)")
                        span.bet-type-text(v-if="['OU','OE'].includes(betsinglemmo.betType)") {{ $t("m.GX_" + betsinglemmo.betDisplay.toUpperCase()) }}
                        span.bet-type-text(v-else) {{ $t("m.GX_" + betsinglemmo.betType + (betsinglemmo.ballDisplay == undefined ? '' : betsinglemmo.ballDisplay)) }}
                      template(v-if="racingList4.includes(betsinglemmo.sportsType)")
                        span.bet-type-text(v-if="['OU','OE','ML','1X2'].includes(betsinglemmo.betType)") {{ $t("m.GR_" + betsinglemmo.betDisplay.toUpperCase()) }}
                        span.bet-type-text(v-else-if="['CS'].includes(betsinglemmo.betType)") {{ betsinglemmo.betDisplay }}
                        span.bet-type-text(v-else) {{ $t("m.GR_" + betsinglemmo.betType + (betsinglemmo.ballDisplay == undefined ? '' : betsinglemmo.ballDisplay)) }}
                      template(v-if="racingList5.includes(betsinglemmo.sportsType)")
                        span.bet-type-text(v-if="['OU','OE'].includes(betsinglemmo.betType)") {{ $t("m.MA_" + betsinglemmo.betType + (betsinglemmo.homeAway == undefined ? '' : betsinglemmo.homeAway)) }}
                        template(v-else-if="['ML'].includes(betsinglemmo.betType)")
                          template(v-if="betsinglemmo.homeName == betsinglemmo.awayName")
                            span.bet-type-text(v-if="betsinglemmo.homeAway==1")   {{ $t("m.MA_ANY_W_R")   }}
                            span.bet-type-text(v-else)   {{ $t("m.MA_NO_W_R")   }}
                          span.bet-type-text(v-else)  {{ $t("m.MA_" + betsinglemmo.betType + (betsinglemmo.homeAway == undefined ? '' : betsinglemmo.homeAway)) }}
                        template(v-else-if="['CS'].includes(betsinglemmo.betType)")
                          span.bet-type-text(v-if="betsinglemmo.criteria2")  {{ betsinglemmo.criteria2 }} 
                          template(v-else-if="betsinglemmo.homeName == betsinglemmo.awayName")
                            span.bet-type-text(v-if="['3-0'].includes(betsinglemmo.betDisplay)")  {{ $t("m.MA_PF") }}
                            span.bet-type-text(v-else) {{ $t("m.MA_W_" + betsinglemmo.betDisplay.split('-')[0]) }}
                          span.bet-type-text(v-else) {{ betsinglemmo.betDisplay }}
                        span.bet-type-text(v-else) {{ $t("m.MA_" + betsinglemmo.betType) }}
                      template(v-if="racingList6.includes(betsinglemmo.sportsType)")
                        span.bet-type-text(v-if="['ML','OE'].includes(betsinglemmo.betType)") {{ $t("m.CF_" + betsinglemmo.betType + (betsinglemmo.homeAway == undefined ? '' : betsinglemmo.homeAway)) }}
                        span.bet-type-text(v-else-if="['CS'].includes(betsinglemmo.betType)") {{ betsinglemmo.betDisplay }}
                        span.bet-type-text(v-else) {{ $t("m.CF_" + betsinglemmo.betType) }}
                      .bet-type-odds
                        span {{betsinglemmo.val}}
                        .odds
                          span(:class="{ 'negetive' : betsinglemmo.val < 0 }") {{ betsinglemmo.val }}
                    template(v-else)
                      span.text(:class="isBallDisplay == false ? '' : ((betsinglemmo.giving == 0 && betsinglemmo.homeAway == 2) ? 'team2' : (betsinglemmo.giving == 1 && betsinglemmo.homeAway == 1) ? 'team2' : 'team1')") {{ betsinglemmo.marketType == 3 && betsinglemmo.score != '' ? "[" + betsinglemmo.score + "]" : "" }} {{ betsinglemmo.betType }} | {{ betsinglemmo.betDisplay }}
                      .bet-type-odds
                        template(v-if="betsinglemmo.fact.ball_display < 0")
                          span.negetive {{ betsinglemmo.fact.ball_display }}
                        template(v-else)
                          span {{ betsinglemmo.fact.ball_display }}
                        template(v-if="betsinglemmo.fact.criteria2 < 0")
                          span.mr-1.negetive ({{ betsinglemmo.fact.criteria2 }})
                        template(v-else)
                          span.mr-1 ({{ betsinglemmo.fact.criteria2 }})
                        .odds
                          span(:class="{ 'negetive' : betsinglemmo.val < 0 }") {{ betsinglemmo.val }}
              .odds-change-notice(v-if="betsinglemmo.oddsChanged")
                i.fal.fa-exclamation-circle.text-warning.mr-1
                span {{ $t("message.odds_changed") }} {{ betsinglemmo.oddsChangedText }} &#8594; {{ betsinglemmo.val }}
              .odds-change-notice(v-if="betsinglemmo.ldiffChanged")
                i.fal.fa-exclamation-circle.text-warning.mr-1
                span {{ $t("message.ldiff_changed") }} {{ betsinglemmo.ldiffChangedText }} &#8594; {{ betsinglemmo.fact.criteria2 }}
              .odds-change-notice(v-if="oddsIsUpdating || invalidOdds")
                i.fal.fa-exclamation-circle.text-warning.mr-1
                span {{ $t("error.oddsIsUpdating") }}
              .odds-change-notice(v-if="errorMessage")
                i.fal.fa-exclamation-circle.text-danger.mr-1
                span {{ errorMessage }}
            .footer-slip.text-left
              .payout-wrapper
                .left {{ $t("ui.min") }}: {{ $numeral(betsinglemmo.minBet).format("0,0") }} | {{ $t("ui.max") }}: {{ $numeral(betsinglemmo.maxBet).format("0,0") }}
                .right {{ $t("ui.payout") }}: {{ $numeral(payout).format("0,0.00[0]") }}
              .stake-wrapper
                .d-flex.justify-content-between.flex-fill.mr-1.bet-input
                  .d-flex.align-items-center.flex-fill.mr-1.stake-input-wrapper
                    .stake-mask.flex-fill(@click="runTapAction(maskStake, $event)" @touchend="runTapAction(maskStake, $event)")
                      StakeInput(v-model="stake" @handleStake="handleStake" ref="stake" :loadbet="loading.check")
                    .text-secondary.stake-cancel.pl-2.pr-2(v-show="showStakeCancel" @click="clearStake")
                      i.fas.fa-times
                #place-bet.place-bet
                  SpinButton(css="btn-warning btn-sm rounded-0 text-center text-uppercase" @click="processConfirmBet" :text="$t('ui.process_bet')" :loading="loading.process")
              .betslip-cashout.p-2.m-2(v-if="betsinglemmo.cashout == 1 && ['HDP', 'HDPH', 'OU', 'OUH'].includes(betsinglemmo.betType)")
                span.text-success
                  i.fas.fa-check-circle
                span(style='opacity: .5;') {{ $t("ui.cashout") }}
                span.text-success {{ $t("ui.available") }}
              .keyboard(@click="handleKeyboardInteraction" @touchend="handleKeyboardInteraction")
                .pt-2.pl-2.pr-2.pb-1.cluster
                  .row.mx-0
                    .col-2.px-0.text-center.button-tap(data-kb="1")
                      span 1
                    .col-2.px-0.text-center.button-tap(data-kb="2")
                      span 2
                    .col-2.px-0.text-center.button-tap(data-kb="3")
                      span 3
                    .col-2.px-0.text-center.button-tap(data-kb="4")
                      span 4
                    .col-2.px-0.text-center.button-tap(data-kb="5")
                      span 5
                    .col-2.px-0.text-center.button-tap.special.pt-2.del(data-kb="del")
                      span DEL
                      br
                      i.fas.fa-long-arrow-alt-left
                  .row.mx-0
                    .col-2.px-0.text-center.button-tap(data-kb="6")
                      span 6
                    .col-2.px-0.text-center.button-tap(data-kb="7")
                      span 7
                    .col-2.px-0.text-center.button-tap(data-kb="8")
                      span 8
                    .col-2.px-0.text-center.button-tap(data-kb="9")
                      span 9
                    .col-2.px-0.text-center.button-tap(data-kb="0")
                      span 0
                    .col-2.px-0.text-center.button-tap(data-kb="00")
                      span 00
                .pt-2.pl-2.pr-2.pb-0
                  .row.mx-0
                    .col-3.px-0.text-center.add-stake.btn-min(data-kb="min")
                      span {{ $t("ui.min") }}
                    .col-3.px-0.text-center.add-stake(data-kb="add:50")
                      span + 50
                    .col-3.px-0.text-center.add-stake(data-kb="add:100")
                      span + 100
                    .col-3.px-0.text-center.add-stake.btn-max(data-kb="max")
                      span {{ $t("ui.max") }}
              .bet-infosub
                .checkbox
                  label.d-flex(@click="handleAcceptBetterOdds")
                    input(type="checkbox" :checked="betting.acceptBetterOdds == 'true'")
                    span.label(@click="handleAcceptBetterOdds") {{ $t("ui.accept_better_odds") }}
                .checkbox
                  label.d-flex(@click="handleRememberStake")
                    input(type="checkbox" :checked="betting.defaultStake == '0'")
                    span.label(@click="handleRememberStake") {{ $t("ui.remember_stake") }}
</template>

<script>
import { EventBus } from "@/library/_event-bus.js";
import xhrBet from "@/library/_xhr-betmmo.js";
import calc from "@/library/_calculation.js";
import config from "@/config";
import StakeInput from "@/components/mobile/bets/new/stakeInput";
import SpinButton from "@/components/ui/SpinButton";
import mixinBetType from "@/library/mixinBetType";
import mixinDelay from "@/library/mixinDelay";
import mixinKeyboardTap from "@/library/mixinKeyboardTap";
import naming from "@/library/_name";

export default {
  components: {
    SpinButton,
    StakeInput
  },
  mixins: [mixinBetType, mixinDelay, mixinKeyboardTap],
  data() {
    return {
      errorMessage: "",
      debounceBet: null,
      loading: {
        check: false,
        cancel: false,
        process: false
      },
      league: {},
      match: {},
      defaultCounter: 10,
      counter: 10,
      placeSlip: {},
      stake: null,
      customStake: null,
      payout: null,
      invalidOdds: false,
      oddsIsUpdating: false,
      autoCloseOddsIsUpdating: null,
      betConfirm: false,
      setParlay: false,
      isMMO: false,
      singleOdds: null,
      oddsType: null,
      oddsPosition: null,
      cancelGeneration: 0
    };
  },
  computed: {
    racingList() {
      return config.racingList;
    },
    racingList1() {
      return config.racingList1;
    },
    racingList2() {
      return config.racingList2;
    },
    racingList3() {
      return config.racingList3;
    },
    racingList4() {
      return config.racingList4;
    },
    racingList5() {
      return config.racingList5;
    },
    racingList6() {
      return config.racingList6;
    },
    racingList7() {
      return config.racingList7;
    },
    mmoMode() {
      return this.$store.getters.mmoMode;
    },
    isBallDisplay() {
      // var result = naming.ballDisplay2(this.betsinglemmo.ballOrigin, this.betsinglemmo.giving, this.betsinglemmo.homeAway, this.betsinglemmo.betType, this);
      var result = naming.ballDisplay2(this.betsinglemmo.fact.ball_display, this.betsinglemmo.giving, this.betsinglemmo.homeAway, this.betsinglemmo.betType, this);
      if (["HDP", "HDPH"].includes(this.betsinglemmo.betType)) {
        return result != null && result != "0";
      } else {
        return false;
      }
    },
    betTypeDisplay() {
      return this.$t("m.BS_" + this.betsinglemmo.betType);
    },
    commType() {
      return this.$store.getters.commType;
    },
    debug() {
      return config.debugMode;
    },
    betsinglemmo() {
      return this.$store.state.betsinglemmo;
    },
    pageDisplay() {
      return this.$store.getters.pageDisplay;
    },
    betting() {
      return this.$store.getters.betting;
    },
    currencyCode() {
      return this.$store.getters.currencyCode.replace("UST", "USDT");
    },
    isDataExists() {
      if (this.betsinglemmo.hasOwnProperty("val")) {
        return true;
      } else {
        return false;
      }
    },
    betsingleValue() {
      return this.betsinglemmo.val;
    },
    betsingleMulti() {
      return this.betsinglemmo.multi;
    },
    sports() {
      return this.$store.state.layout.sports;
    }
  },
  watch: {
    stake(newVal) {
      this.handlePayout();
    },
    betsingleValue(newVal) {
      this.handlePayout();
    },
    betsingleMulti(newVal) {
      this.handlePayout();
    }
  },
  destroyed() {
    $("#betslip-single-mmo").off("shown.bs.modal", this.handleShownMe);
    $("#betslip-single-mmo").off("hidden.bs.modal", this.handleHiddenMe);
    clearInterval(this.runner);
  },
  mounted() {
    this.debounceBet = this.debounce(this.processBet, 200);
    setInterval(this.runner, this.defaultCounter * 1000);
    EventBus.betSingleMMO = this.runbet;
    EventBus.cancelSingleMMO = this.cancelBet;

    $("#betslip-single-mmo").on("shown.bs.modal", this.handleShownMe);
    $("#betslip-single-mmo").on("hidden.bs.modal", this.handleHiddenMe);
  },
  methods: {
    handleShownMe() {
      $("#place-bet").show();
      this.armKeyboardGuard();
      this.$nextTick(() => {
        this.showKeyboard();
      });
    },
    handleHiddenMe() {
      // $(".odd-value").removeClass("selected-odds");
      $(".odd").removeClass("selected-odds");
      $("#place-bet").show();
      this.cancelBetClick();
    },
    getBallDisplay(b, g, ha, bt) {
      return naming.ballDisplay2(b, g, ha, bt, this);
    },
    runbet(odds, typ, idx, val, bt, amt, allowParlay, isMMO, e, pos) {
      if (!isMMO && !this.mmoMode) {
        this.$helpers.showDialog(this.$t("ui.action"), this.$t("error.invalidCurrency"), "error");
        return;
      }
      if (EventBus.cancelSingle) EventBus.cancelSingle();

      this.cancelGeneration += 1;
      this.loading.process = false;
      this.singleOdds = odds;
      this.oddsType = typ;
      this.setParlay = allowParlay;
      this.isMMO = isMMO;
      this.oddsPosition = pos;
      this.stake = "";
      this.customStake = null;
      this.errorMessage = "";
      this.betConfirm = false;
      this.handleStake();
      this.checkSingleBet(odds, typ, idx, val, bt, e, pos);
      this.showMe();
      this.armKeyboardGuard();
      this.bindKeyboard();
      this.$nextTick(() => {
        this.showKeyboard();
        if (this.$refs.stake) {
          this.$refs.stake.focus();
        }
      });
      clearTimeout(this.autoCloseOddsIsUpdating);
      this.invalidOdds = false;
      this.oddsIsUpdating = false;
    },
    runner() {
      this.autoRefresh();
    },
    cache() {
      return this.$store.getters.data;
    },
    bindKeyboard() {
      document.onkeyup = event => {
        if (event.which == 13 || event.keyCode == 13) {
          this.processConfirmBet();
        } else {
          if (event.which == 27 || event.keyCode == 27) {
            this.cancelBet("bindKeyboard");
          }
        }
      };
    },
    fastBet() {
      if (this.isDataExists) {
        this.handleStake();
        this.$swal({ title: this.$t("ui.confirmation"), text: this.$t("message.confirmation"), type: "info", showCancelButton: true }).then(result => {
          if (result.value) {
            this.processConfirmBet();
          }
        });
      }
    },
    processConfirmBet() {
      if (!this.validateStakeForPlaceBet()) {
        return;
      }
      this.loading.process = false;
      this.betConfirm = true;
      this.loadingBet();
    },
    cancelProcess() {
      this.betConfirm = false;
    },
    getBetLimit(st) {
      var result = {
        min_bet: 0,
        max_bet: 0,
        max_payout: 0
      };
      if (st) {
        switch (parseInt(st)) {
          case 1:
            result = this.$store.getters.playerBetLimit["SOCCER"];
            break;
          case 2:
            result = this.$store.getters.playerBetLimit["BASKETBALL"];
            break;
          case 7:
            result = this.$store.getters.playerBetLimit["TENNIS"];
            break;
          case 8:
            result = this.$store.getters.playerBetLimit["BASEBALL"];
            break;
          case 20:
            result = this.$store.getters.playerBetLimit["ESPORTS"];
            break;
          default:
            result = this.$store.getters.playerBetLimit["OTHERS"];
            break;
        }
      }

      return result;
    },
    showMe() {
      $("#betslip-single-mmo").modal("show");
    },
    hideMe() {
      $("#betslip-single-mmo").modal("hide");
    },
    handlePayout() {
      var a = this.stake * this.betsinglemmo.multi;
      var b = this.betsinglemmo.maxBet * this.betsinglemmo.multi;
      if (a > b) {
        a = b;
      }
      this.payout = a.toFixed(3);
      this.$store.dispatch("betsinglemmo/setStake", this.stake);
    },
    handleStake() {
      if (this.stake % 1 != 0) {
        this.stake = Math.round(this.stake);
      }
    },
    forceHandleStake() {},
    clearStake() {
      this.stake = "";
    },
    minStake() {
      this.stake = this.betsinglemmo.minBet;
    },
    maxStake() {
      this.stake = this.betsinglemmo.maxBet;
    },
    maskStake() {},
    keyStake(e) {
      if (!!this.stopBet) return;
      this.stake = this.buildStakeFromDigit(e);
    },
    deleteStake() {
      var c = this.getStakeString();
      if (c.length > 0) {
        this.stake = c.slice(0, -1);
        this.handleStake();
      }
    },
    doneStake() {
      $("#place-bet").show();
    },

    refreshOddsYes() {
      this.invalidOdds = false;
      this.counter = this.defaultCounter;
      this.requestSingleBet(this.betsinglemmo, "refresh");
    },
    refreshOddsNo() {
      this.invalidOdds = false;
    },
    checkMatchExists() {
      var result = true;
      if (this.betsinglemmo != null) {
        var cache = this.cache();
        if (cache != null && cache.hasOwnProperty("match")) {
          if (!cache.match.hasOwnProperty(this.betsinglemmo.matchId)) {
            result = false;
            this.cancelBet("checkMatchExists");
          }
        } else {
          result = false;
          this.cancelBet("checkMatchExists");
        }
      }
      return result;
    },
    autoRefresh() {
      if (this.isDataExists) {
        if ((this.betting.autoRefreshOdds == true || this.betting.autoRefreshOdds == "true") && this.isDataExists) {
          this.requestSingleBet(this.betsinglemmo, "refresh");
        }
      }
    },
    handleAutoRefresh() {
      this.$store.dispatch("layout/setSingleBetting", { property: "autoRefreshOdds", value: this.betting.autoRefreshOdds == "true" ? "false" : "true" });
      this.counter = this.defaultCounter;
    },
    handleAcceptBetterOdds() {
      this.$store.dispatch("layout/setSingleBetting", { property: "acceptBetterOdds", value: this.betting.acceptBetterOdds == "true" ? "false" : "true" });
    },
    handleRememberStake() {
      this.$store.dispatch("layout/setSingleBetting", { property: "defaultStake", value: this.betting.defaultStake == "0" ? "3" : "0" });
    },
    loadingBet() {
      this.loading.process = true;
      if (this.debounceBet) {
        this.debounceBet();
      }
    },
    processBet() {
      if (!this.betConfirm || Object.keys(this.betsinglemmo).length <= 3) return;
      if (!this.validateStakeForPlaceBet()) {
        return;
      }
      this.betConfirm = false;
      this.loading.process = true;
      var old = this.placeSlip;
      this.placeSlip = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        odds_id: this.betsinglemmo.oddsId,
        submatch_id: this.betsinglemmo.subMatchId,
        match_id: this.betsinglemmo.matchId,
        bet_type: this.betsinglemmo.betType,
        bet_member: this.stake,
        bet_team_id: this.betsinglemmo.betTeamId,
        home_away: this.betsinglemmo.homeAway,
        odds_display: parseFloat(this.betsinglemmo.val),
        odds_mo: parseFloat(this.betsinglemmo.origin),
        odds_type: this.betsinglemmo.typId,
        accept_better_odds: this.betting.acceptBetterOdds,
        ball_display: this.betsinglemmo.ballDisplay,
        criteria2: this.betsinglemmo.fact.criteria2,
        operator_type: this.$store.getters.operatorType,
        parent_id: this.$store.getters.parentId,
        market_type: this.betsinglemmo.marketType
      };
      old = null;
      var cloneSlip = Object.assign({}, this.betsinglemmo);
      cloneSlip.stake = this.stake.toString();
      cloneSlip.payout = this.payout.toString();
      xhrBet.betSingle(this.placeSlip).then(
        res => {
          if (this.$store.state.layout.betting.defaultStake == "0") {
            this.$store.dispatch("layout/setSingleBetting", { property: "defaultStakeAmount", value: this.stake });
          }

          this.hideMe();

          if (EventBus.betSingleStatusMMO) {
            EventBus.betSingleStatusMMO(cloneSlip, res);
          }

          this.cancelBet("processBet");
          if (EventBus.getBalance) {
            EventBus.getBalance();
          }
        },
        err => {
          this.loading.process = false;
          this.handleChecking(err.status, "processBetError");
        }
      );
    },
    handleChecking(e, m) {
      this.loading.check = false;
      switch (e) {
        case "insufficient_balance":
          this.errorMessage = this.$t("error.insufficient_balance");
          break;
        case "betLowerMin":
          this.rejectStakeLimitViolation("min");
          break;
        case "betOverLimit":
        case "betOverMax":
        case "betOverMaxBet":
        case "betOverMaxPerMatch":
          this.rejectStakeLimitViolation("max");
          break;
        case "betAmountRequired":
        case "bet_amount_required":
        case "minBetAmount":
        case "invalidBetAmount":
          this.rejectBetWithFeedback(e);
          break;
        case "invalidOdds":
          this.invalidOdds = true;
          this.refreshOddsYes();
          break;
        case "oddsIsUpdating":
        case "oddsDisplayInvalid":
        case "invalidOddsBall":
          this.oddsIsUpdating = true;
          clearTimeout(this.autoCloseOddsIsUpdating);
          this.autoCloseOddsIsUpdating = setTimeout(() => {
            this.oddsIsUpdating = false;
            this.oddsDisplayInvalid = false;
            this.invalidOddsBall = false;
          }, this.defaultCounter * 1000);
          break;
        default:
          this.loading.process = false;
          this.betConfirm = false;
          if (m === "processBetError") {
            this.$helpers.handleFeedback(e);
          } else {
            this.cancelBet(m);
            this.$helpers.handleFeedback(e);
          }
          break;
      }
    },
    cancelBetClick() {
      this.cancelBet("cancelBetClick");
    },
    cancelBet(e) {
      const generation = ++this.cancelGeneration;
      clearTimeout(this.autoCloseOddsIsUpdating);
      this.invalidOdds = false;
      this.oddsIsUpdating = false;
      this.loading.cancel = true;
      this.league = {};
      this.match = {};
      this.counter = this.defaultCounter;
      this.$store.dispatch("betsinglemmo/clearData").then(() => {
        if (generation !== this.cancelGeneration) {
          return;
        }
        this.loading.cancel = false;
        this.loading.process = false;
      });
      this.loading.check = false;
      this.loading.process = false;
      // $(".odd-value").removeClass("selected-odds");
      $(".odd").removeClass("selected-odds");
    },

    checkSingleBet(odds, typ, idx, val, bt, e, pos) {
      this.counter = this.defaultCounter;
      this.loading.check = true;
      var cache = this.cache();
      if (cache.hasOwnProperty("league") && cache.hasOwnProperty("match")) {
        var sd = {};
        sd.typ = typ;
        sd.idx = idx;
        sd.val = val;
        sd.pos = pos;
        sd.origin = val;

        sd.leagueId = odds[0];
        sd.matchId = odds[1];
        sd.subMatchId = odds[2];
        sd.oddsId = odds[3];
        sd.betType = odds[4];
        sd.ballOrigin = odds[8];
        sd.target = bt;

        this.league = cache.league[sd.leagueId];
        this.match = cache.match[sd.matchId];

        sd.sportsType = this.league[1];
        sd.leagueId = this.league[0];
        sd.leagueName = this.league[4];

        sd.marketType = this.match[4];
        sd.homeName = this.match[5];
        sd.awayName = this.match[6];
        sd.workingDate = this.match[7];
        sd.matchTime = this.match[8];
        sd.homeId = this.match[22];
        sd.awayId = this.match[23];
        sd.score = this.match[11] ? this.match[11].toString().trim() : "";
        sd.awayId = this.match[23];
        sd.typId = config.oddsTypeId[sd.typ];
        sd.ballDisplay = "";
        sd.betDisplay = "";
        sd.oddsChanged = false;
        sd.ballChanged = false;
        sd.oddsChangedText = "";
        sd.ballChangedText = "";
        var limit = this.getBetLimit(sd.sportsType);
        sd.minBet = limit.min_bet;
        sd.maxBet = limit.max_bet;
        sd.maxPayout = limit.max_payout;
        if (config.marking.includes(sd.betType)) {
          if (sd.val > 0) {
            sd.multi = (parseFloat(sd.val) + 1).toFixed(3);
          } else {
            sd.multi = (Math.abs(parseFloat(sd.val)) + 1).toFixed(3);
          }
        } else {
          sd.multi = sd.val;
        }
        this.setBetTypeMMO(sd, odds);
        this.$store.dispatch("betsinglemmo/newData", sd);
        this.$nextTick(() => {
          this.showKeyboard();
        });
        this.league = null;
        this.match = null;
        this.requestSingleBet(sd, e);
      }
    },
    requestSingleBet(data, e) {
      this.invalidOdds = false;
      this.errorMessage = "";

      if (data == null) {
        this.cancelBet("requestSingleBetNoData");
        return;
      }

      if (!data.betType || !data.oddsId || !data.sportsType || data.origin == null) {
        this.cancelBet("requestSingleBetInvalid");
        return;
      }

      var slip = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        sports_type: data.sportsType,
        parlay: data.target == "parlay",
        odds_id: data.oddsId,
        submatch_id: data.subMatchId,
        bet_type: data.betType,
        bet_team_id: data.betTeamId,
        home_away: data.homeAway,
        odds_display: parseFloat(data.val),
        odds_mo: parseFloat(data.origin),
        odds_type: data.typId,
        ball_display: data.ballDisplay,
        criteria2: data.fact.criteria2,
        market_type: data.marketType
      };
      xhrBet.betSingleOddsCheck(slip).then(
        res => {
          if (res.success) {
            if (data != null) {
              var sd = Object.assign({}, data);

              sd.cashout = res.data[0].cashout;

              sd.oddsChanged = res.data[0].odds_change;
              sd.ldiffChanged = res.data[0].ldiff_change;
              sd.ballChanged = res.data[0].ball_change;
              if (res.data[0].home_giving == true) {
                sd.giving = 1;
              } else {
                sd.giving = 0;
              }
              if (res.data[0].ball_display_new != null) {
                sd.ballChangedText = this.getBallDisplay(sd.ballDisplay, sd.giving, sd.homeAway, sd.betType);
                sd.ballDisplay = res.data[0].ball_display_new;
              }
              if (res.data[0].ldiff_new != null) {
                sd.ldiffChangedText = sd.fact.criteria2;
                sd.criteria2 = res.data[0].ldiff_ori;
                sd.fact = naming.ballDisplayMMO(sd.ballDisplay.toString(), sd.giving, sd.homeAway, sd.betType, sd.criteria2);
                // var fact = {
                //   ball_display: sd.fact.ball_display,
                //   criteria2: res.data[0].ldiff_new,
                // };
                // sd.fact = fact;
              }
              if (res.data[0].odds_display_new != null) {
                sd.oddsChangedText = sd.val;
                sd.val = calc.fmtType(res.data[0].odds_display_new, this.commType, sd.betType);
              }
              if (res.data[0].odds_new != null) {
                sd.origin = calc.fmt(res.data[0].odds_new);
              }
              if (sd.minBet < res.data[0].min_bet) {
                sd.minBet = res.data[0].min_bet;
              }
              if (sd.maxBet > res.data[0].max_bet) {
                sd.maxBet = res.data[0].max_bet;
              }
              if (sd.maxPayout > res.data[0].max_parlay_payout) {
                sd.maxPayout = res.data[0].max_parlay_payout;
              }
              if (config.marking.includes(sd.betType)) {
                if (sd.val > 0) {
                  sd.multi = (parseFloat(sd.val) + 1).toFixed(3);
                } else {
                  sd.multi = (Math.abs(parseFloat(sd.val)) + 1).toFixed(3);
                }
              } else {
                sd.multi = sd.val;
              }

              this.$store.dispatch("betsinglemmo/setData", sd);
              this.handleStake();
              this.loading.check = false;
              this.invalidOdds = false;
            }
          } else {
            this.handleChecking(err.status, "requestSingleBetElse");
          }
        },
        err => {
          this.handleChecking(err.status, "requestSingleBetError");
        }
      );
    }
  }
};
</script>
